/* unplugin-vue-components disabled */import { render } from "./flimit-modal.vue?vue&type=template&id=6594bacd&scoped=true"
import script from "./flimit-modal.vue?vue&type=script&lang=js"
export * from "./flimit-modal.vue?vue&type=script&lang=js"

import "./flimit-modal.vue?vue&type=style&index=0&id=6594bacd&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6594bacd"],['__file',"src/pages/settings/admin/flimit-modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6594bacd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6594bacd', __exports__)) {
    api.reload('6594bacd', __exports__)
  }
  
  module.hot.accept("./flimit-modal.vue?vue&type=template&id=6594bacd&scoped=true", () => {
    api.rerender('6594bacd', render)
  })

}


export default __exports__